// extracted by mini-css-extract-plugin
export default {"wrapper":"mq-z","response":"nq-z","error":"oq-z","disabled":"pq-z","buttons":"qq-z","feedbackQuestionSection":"rq-z","yesNoWrapper":"sq-z"};